import React from 'react'

import {FOOTER_SIMPLE_LINKS, FOOTER_SOCIAL_LINKS} from './links'

import RamblerFooter from '@rambler-components/footer'

import '@rambler-components/footer/styles.css'

export const Footer = () => (
  <RamblerFooter
    type="dark"
    simpleLinks={FOOTER_SIMPLE_LINKS}
    socialLinks={FOOTER_SOCIAL_LINKS}
  />
)
